import React, { FC } from 'react';
import './somethingWentWrong.scss';
import down from '@src/LottieAnimations/websiteDown.json';
import { LottieLite } from '@src/LottieAnimations/LottieLite';

const SomethingWentWrong: FC = () => {

  return (
    <div data-test-id="c-something-went-wrong" className="wrongWrapper">
      <LottieLite animationData={down} style={{ width: 700, height: 700 }} />
      <h2>Something Went Wrong!</h2>
      <button onClick={() => (window.location.href = '/')}>
        Go To Home Page
      </button>
    </div>
  );
};

export default SomethingWentWrong;
